import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult, SilentRequest } from '@azure/msal-browser';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private msalService: MsalService) {}

  /**
   * Attempt SSO silent login
   */
  ssoSilent(): Observable<AuthenticationResult | null> {
    const silentRequest: SilentRequest = {
      scopes: ['user.read'],
    //   loginHint: this.getLoginHint()
    };

    return from(
      this.msalService.instance
        .ssoSilent(silentRequest)
        .catch((error) => {
          console.log('SSO Silent failed', error);
          return null;
        })
    );
  }

  /**
   * Acquire token silently for API calls
   */
  acquireTokenSilent(scopes: string[]): Observable<AuthenticationResult> {
    const account = this.msalService.instance.getActiveAccount();
    
    if (!account) {
      throw new Error('No active account');
    }

    return from(
      this.msalService.acquireTokenSilent({
        scopes: scopes,
        account: account
      })
    );
  }

  isLoggedIn(): boolean {
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  getLoginHint(): string | undefined {
    const account = this.msalService.instance.getActiveAccount();
    return account?.username;
  }

  getUserName(): string {
    const account = this.msalService.instance.getActiveAccount();
    
    if (!account) {
      return 'User';
    }

    // Extract name from username (email) format: FirstName.LastName@domain.com
    if (account.username) {
      const emailPart = account.username.split('@')[0]; // Get "FirstName.LastName"
      const nameParts = emailPart.split('.'); // Split by dot
      
      if (nameParts.length >= 2) {
        // Capitalize first letter of each part
        const firstName = nameParts[0].charAt(0).toUpperCase() + nameParts[0].slice(1).toLowerCase();
        const lastName = nameParts[1].charAt(0).toUpperCase() + nameParts[1].slice(1).toLowerCase();
        return `${firstName} ${lastName}`;
      }
    }

    // Fallback to account name or username
    return account.name || account.username || 'User';
  }

  getUserEmail(): string {
    const account = this.msalService.instance.getActiveAccount();
    return account?.username || '';
  }

  login() {
    this.msalService.loginRedirect({
      scopes: ['user.read']
    });
  }

  logout() {
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: window.location.origin
    });
  }
}